module.exports = __webpack_public_path__ + "static/media/icon-dev-3.93ef2571.svg";